import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifyError, notifySuccess } from '@/lib/notify';
import { notificationKeys } from '@/layout/NotificationBell';
import { drKeys } from './api';

/** Mutation for any document-request action: refreshes request/task data and notifications, shows a toast. */
export function useDrAction<TVars = void, TResult = unknown>(
  fn: (vars: TVars) => Promise<TResult>,
  success?: string | ((vars: TVars) => string),
  onDone?: (result: TResult, vars: TVars) => void,
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: async (result, vars) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: drKeys.all }),
        queryClient.invalidateQueries({ queryKey: notificationKeys.all }),
      ]);
      if (success) notifySuccess(typeof success === 'function' ? success(vars) : success);
      onDone?.(result, vars);
    },
    onError: (error) => notifyError(error),
  });
}
